(() => {
  if (customElements.get('bs-filled-product-heading')) return;

  class FilledProductHeading extends HTMLElement {
    static get observedAttributes() { return ['data-full-title']; }

    connectedCallback() {
      this.heading = this.querySelector('.bs-filled-product-heading__title');
      this.text = this.querySelector('[data-title-text]');
      if (!this.heading || !this.text) return;
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.fit());
      };
      this.observer = new ResizeObserver(entries => {
        const width = entries[0].contentRect.width;
        if (width === this.lastWidth) return;
        this.lastWidth = width;
        this.schedule();
      });
      this.observer.observe(this);
      window.addEventListener('resize', this.schedule, { passive: true });
      document.fonts?.addEventListener('loadingdone', this.schedule);
      document.fonts?.ready.then(() => { if (this.isConnected) this.schedule(); });
      this.schedule();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      window.removeEventListener('resize', this.schedule);
      document.fonts?.removeEventListener('loadingdone', this.schedule);
      this.lastWidth = undefined;
    }

    attributeChangedCallback() { this.schedule?.(); }

    fit() {
      if (!this.isConnected || !this.heading || !this.text) return;
      const available = this.heading.clientWidth - 0.5;
      if (available <= 0) return;
      const fullTitle = this.dataset.fullTitle?.trim();
      if (!fullTitle) return;

      // Start fresh so a wider layout restores the original wording and type size.
      this.heading.style.removeProperty('font-size');
      this.heading.setAttribute('aria-label', fullTitle);
      this.heading.dataset.originalTitle = fullTitle;
      this.text.textContent = fullTitle;
      const baseSize = parseFloat(getComputedStyle(this.heading).fontSize);
      const fits = () => this.text.getBoundingClientRect().width <= available;
      if (fits()) return;

      const shorterTitle = fullTitle
        .replace(/(^|[^\p{L}\p{N}])ballon(?:nen)?(?=$|[^\p{L}\p{N}])/giu, '$1')
        .replace(/\s+/g, ' ')
        .replace(/\s+([,.;:!?])/g, '$1')
        .replace(/^\s*[-–—:,]\s*|\s*[-–—:,]\s*$/g, '')
        .trim();
      if (/[\p{L}\p{N}]/u.test(shorterTitle)) this.text.textContent = shorterTitle;
      if (fits()) return;

      // Find the largest size that fits without clipping or adding an ellipsis.
      let low = 1;
      let high = baseSize;
      for (let step = 0; step < 12; step += 1) {
        const size = (low + high) / 2;
        this.heading.style.setProperty('font-size', `${size}px`, 'important');
        if (fits()) low = size;
        else high = size;
      }
      this.heading.style.setProperty('font-size', `${Math.floor(low * 100) / 100}px`, 'important');
    }
  }

  customElements.define('bs-filled-product-heading', FilledProductHeading);
})();
